import { createApp } from "vue"
import "@fontsource/inter/cyrillic-400.css"
import "@fontsource/inter/cyrillic-500.css"
import "@fontsource/inter/cyrillic-600.css"
import "@fontsource/inter/cyrillic-700.css"
import "@fontsource/inter/latin-400.css"
import "@fontsource/inter/latin-500.css"
import "@fontsource/inter/latin-600.css"
import "@fontsource/inter/latin-700.css"
import "./brand.css"
import MainApp from "../pages/MainApp.vue"

createApp(MainApp).mount("#app")
